import React, { Component } from 'react';
import './styles.css';
import { Document, Page } from 'react-pdf';

import NavBar from '../NavBar/'

export default class Resume extends Component {

  componentDidMount() {
    setTimeout(() => {
      this._addEvent();
    },2000);
  }

  _addEvent() {
    var x = document.querySelector('.resume-container');
    if( !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      try {
        x.addEventListener('click', () => {
          x.style.transform = 'scale(1.5,1.5)';
        })
      }
      catch (err) {
        // console.log(err)
      }
     }
  }


  _rightClick = (e) => {
    e.preventDefault();
    document.querySelector('.resume-container').style.transform = 'scale(1,1)';
  }
  render() {
    return (
      <div onContextMenu={this._rightClick}>
        <NavBar title="Resume"/>
        <Document
          className="resume-container"
          file="Matt_Rays_Resume.pdf"
        >
          <Page pageNumber={1} />
        </Document>
      </div>
    );
  }
};








// WEBPACK FOOTER //
// ./src/components/Resume/index.js